import React, { PropsWithChildren } from "react"
import InnerSectionContainer from "../../../../components/InnerSectionContainer/InnerSectionContainer"
import styles from "./FarePricesSection.module.scss"

const FarePricesSection: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className={styles.container} data-content-name="fares_mosaic">
            <InnerSectionContainer backgroundColor="transparent">
                <div className={styles.mosaic}>{children}</div>
            </InnerSectionContainer>
        </div>
    )
}

export default FarePricesSection
